import { Routes, Route } from "react-router-dom";
import UserAuswahl from './UserAuswahl';
import Personalmappe from "../Personalmappe/Personalmappe";

function MitarbeiterPersonalmappe(props) {
  const { client, accessToken, updateTitle, location } = props;

  return (
    <Routes>
      <Route path="/PERSMA/*" element={<Personalmappe updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} />} />
      <Route path="/" element={<UserAuswahl client={client} accessToken={accessToken} updateTitle={updateTitle} location={location} />} />
    </Routes>
  );
}

export default MitarbeiterPersonalmappe;
